import React from 'react';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const copy = (text) => {
  try {
    navigator.clipboard?.writeText(text);
  } catch (ex) {
    console.error('Could not copy:', ex);
  }
};

// A command that can be copied. Nothing here runs it: the person pastes it where they queue jobs.
export default function CommandRow({ label, command }) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="caption" color="text.secondary" sx={{ minWidth: 48 }}>{label}</Typography>
      <Typography variant="caption" sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>{command}</Typography>
      <Tooltip title={`Copy the ${label.toLowerCase()} command`}>
        <IconButton size="small" aria-label={`Copy ${label.toLowerCase()} command`} onClick={() => copy(command)}>
          <ContentCopyIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
